import React from 'react';
import PropTypes from 'prop-types';
import { FieldTable } from '../../../components/FieldTable/FieldTable';
import { FieldTableColumnProps } from '../../../components/FieldTable/FieldTableTypes';
import { SiteRental } from '../../../generated/graphql';
import {SiteRentalTypeSelect} from "../../../components/MaterialSelects/SiteRentalTypeSelect";
import {TextField, Tooltip} from "@mui/material";
import {SiteRentalPaymentFrequencySelect} from "../../../components/MaterialSelects/SiteRentalPaymentFrequencySelect";
import {SiteRentalPaymentMethodSelect} from "../../../components/MaterialSelects/SiteRentalPaymentMethodSelect";
import { FieldTableTitleTooltip } from '../../../components/FieldTable/FieldTableTitleTooltip';
import { calculateFixedRowValue, uniqueId } from '../../../utils';
import { useDaybookContext } from '../../../contexts/Daybook/DayBookContext';

const columns:FieldTableColumnProps<SiteRental>[] = [
    {
        accessor: 'expand',
        dataType:'expander'
    },
    {
        header:'Type',
        accessor:'rentalType',
        sort:'rentalType.label',
        dataType:'select',
        options: {
            label:'label',
            renderEditor: ({ field }) =>
            <SiteRentalTypeSelect {...field} />
        }
    },{
        header:'Start Date',
        accessor:'start_date',
        dataType:'date'
    },{
        header:'Expiry Date',
        accessor:'expiry_date',
        dataType: 'date'
    },
    ,{
        header:<Tooltip title="Contract rolls over at end"><FieldTableTitleTooltip>Rolling</FieldTableTitleTooltip></Tooltip>,
        accessor:'is_rolling',
        dataType: 'boolean'
    },
    {
        header:'Contact',
        accessor:'contact',
        dataType:'text'
    },
    {
        header:'FH',
        accessor:'freeholder',
        dataType:'boolean',
        summaries: {
            // eslint-disable-next-line react/display-name
            header: () => <b style={{display:'flex',alignItems:'center'}}>Liability</b>
          }
    },
    {
        header:'Amount p.a.',
        accessor:'amount',
        dataType:'currency',
        options: {
            showGlyph: false
        },
        summaries: {
            header: ({ rows }) => {
                return calculateFixedRowValue(rows).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
        }
    },{
        header:'Cancelled',
        accessor:'is_cancelled',
        dataType:'boolean'
    },{
        header:'Method',
        accessor:'paymentMethod',
        dataType:'select',
        options: {
            label:'label',
            renderEditor: ({ field }) =>
                <SiteRentalPaymentMethodSelect {...field} />
        }
    },{
        header:'Payment Frequency',
        accessor:'paymentFrequency',
        dataType:'select',
        options: {
            label:'label',
        // eslint-disable-next-line react/prop-types, react/display-name
            renderEditor: ({ field }) =>
            <SiteRentalPaymentFrequencySelect {...field} />
        }
    }
    /*,{
        header:'Increase',
        accessor:'increase_date',
        dataType: 'date',
    }*/
    /*,{
        header:'Comments',
        accessor:'comments'
        // eslint-disable-next-line react/display-name,react/prop-types
        //editor:({field,error})=><InputGroup {...field} autoFocus={true} error={error}/>
    }*/
];

const newRow = (): SiteRental => ({
    id: uniqueId()
});

const SiteRentalPane = ({values,setValue,readOnly,loading})=> {
    const doChange = (evt) => {
        setValue(evt.target.name, evt.target.value);
        //        console.log('PBP DC',evt.target.name,evt.target.value);
    }
    return (
        <FieldTable columns={columns}
         name="siteRentals" 
        values={values}
        setValue={setValue}
        newRow={newRow}
        loading={loading}
        newRowLabel="Add a new Site Rental"
        className="site-rental"
        defaultSort={[{name:"rentalType.label",asc:true},{name:'start_date',asc:true}]}
        readOnly={readOnly}
        summaries={{ header: (oldRow, newRow) => { return (!newRow ? 'header' : '') } }}
        >{({ name, row }) => {
            return <TextField name={name + '.comments'} multiline={true} onChange={doChange} fullWidth={true} value={row.instructions} placeholder="Comments" />
        }}</FieldTable>
        );
}

SiteRentalPane.propTypes = {
    values: PropTypes.array,
    setValue: PropTypes.func,
    readOnly: PropTypes.bool,
    loading: PropTypes.bool
};

export default SiteRentalPane;

